import AccessorySearch from '@/components/search/AccessorySearch/AccessorySearch'
import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getPageTitle } from '@/utils/helpers'
import { useTranslation } from 'next-i18next'

type Props = {}

const Accessories = (props: Props) => {
  const { t } = useTranslation('common')

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('common:menu.accessories'))}</title>
      </Head>
      <main>
        <AccessorySearch />
      </main>
    </BaseLayout>
  )
}

export default Accessories

export const getStaticProps: GetStaticProps<Props> = async ({
  locale,
}) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'en', [
      'common',
      'shop',
      'footer',
    ])),
  },
})